<template>
   <div class="nav-bar relative cursor-pointer bg-slate-700/50 w-full flex flex-col justify-center items-center group" @click="getPage()">
        <div :class="['fixed top-1/2 -translate-y-1/2 nav-label text-backdrop', direction]">
            <div class="category">{{ subpageTitle }}</div>
            <span v-if="direction == 'prev'" class="title">
                {{ prevPage?.page_title }}
            </span>
            <span v-else class="title">
                {{ nextPage?.page_title }}
            </span>
        </div>
        <div :class="['arrow fixed top-1/2 -translate-y-1/2 text-white/40 group-hover:text-white', direction]">
            <vue-feather v-if="direction=='prev'" type="arrow-left" size="30px" />
            <vue-feather v-if="direction=='next'" type="arrow-right" size="30px" />
        </div>
   </div>
</template>

<script>
import { router } from '@inertiajs/vue3';

export default {
   name: "SubPageNavigation",
   props: ['direction', 'page', 'siblings', 'subpageTitle'],
   computed: {},
   data() {
       return {
            thisIndex: null,
            nextPage: null,
            prevPage: null
       }
   },
   mounted() {
            this.thisIndex=this.siblings?.findIndex(p => p.slug==this. page?.slug);
            this.nextPage=this.siblings[this.thisIndex + 1] ?? null;
            this.prevPage=this.siblings[this.thisIndex - 1] ?? null;
   },
   methods: {
        getPage() {

            if(this.direction == 'next') {
                this.loadPage(this.nextPage);
            }else{
                this.loadPage(this.prevPage);
            }

        },
        loadPage(toPage) {
            const url=this.$page?.url.replace(this.page.slug, toPage.slug);
            router.visit(url);
        }
   }
}
</script>
<style>
.nav-label {
    opacity: 0;
    font-size: .8em;
    width: auto;
    min-width: 140px;
    padding: 2px 6px;
    transition: opacity .5s cubic-bezier(0.165, 0.84, 0.44, 1);

}
.nav-label.next {
    text-align: right;
    margin-right: 50px;
    right: 0;
}
.nav-label.prev {
    text-align: left;
    margin-left: 50px;
    left: 0;
}
.nav-bar {
    height: 200px;
}
.nav-bar:hover .nav-label {
    opacity: 1;
}
.nav-bar .category {
    @apply text-xs uppercase text-slate-400;
}
.nav-bar .title {
    @apply text-base text-slate-200;
}
.nav-bar .arrow {
    transition: all .25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.nav-bar:hover .arrow.next {
    transform: translate(5px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.nav-bar:hover .arrow.prev {
    transform: translate(-5px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
</style>
